import { DAY_NAMES, FORMAT_BADGE } from "@/lib/api";

export default function RhythmTable({ rhythm }) {
  if (!rhythm?.length) return <p className="text-sm text-muted-foreground" data-testid="rhythm-empty">Noch kein Posting-Rhythmus hinterlegt.</p>;
  return (
    <div className="rounded-xl overflow-hidden border border-border" data-testid="rhythm-table">
      <div className="grid grid-cols-[140px_150px_1fr] bg-white text-slate-950 font-mono text-[10px] uppercase tracking-[0.25em] px-5 py-2.5">
        <span>Tag</span><span>Format</span><span>Zweck</span>
      </div>
      {rhythm.map((r) => (
        <div key={r.day} className="grid grid-cols-[140px_150px_1fr] items-center px-5 py-3.5 border-t border-border text-sm" data-testid={`rhythm-row-${r.day}`}>
          <span className="font-semibold">{DAY_NAMES[r.day]} <span className="text-slate-500 font-normal text-xs">{r.time}</span></span>
          <span><span className={`text-[11px] font-semibold px-2.5 py-1 rounded-full ${FORMAT_BADGE[r.format]?.cls}`}>{FORMAT_BADGE[r.format]?.label}</span></span>
          <span className="text-slate-400">{r.purpose || "—"}</span>
        </div>
      ))}
    </div>
  );
}
